export default __webpack_public_path__ + "static/media/vector-right.73fc174b.svg";